import React, { useEffect } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import { selectUserInfo } from '../../../../redux/selectors/authSelector';
import { useSelector } from 'react-redux'

const UserInfo = () => {
    const userInfoFromRedux = useSelector(selectUserInfo);

    const userInfo = {
      username: userInfoFromRedux?.username || localStorage.getItem('username') || 'User123',
      email: userInfoFromRedux?.email || localStorage.getItem('email') || 'user@example.com',
      type: userInfoFromRedux?.type || 'Standard User',
      contactNumber: userInfoFromRedux?.contactNumber || 'Not provided'
    };

  useEffect(() => {
  }, [userInfoFromRedux])

  const InfoCard = ({ icon: Icon, label, value }) => (
    <div
      className="page_h_b2"
      style={{
        backgroundColor: 'white',
        borderRadius: '4px',
        height: '100%',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Icon
          style={{
            color: '#55a4f2',
            marginRight: '15px',
            fontSize: '28px',
          }}
        />
        <div>
          <div
            style={{
              color: '#666',
              fontSize: '12px',
              marginBottom: '4px',
            }}
          >
            {label}
          </div>
          <div
            style={{
              color: '#333',
              fontSize: '16px',
              fontWeight: 500,
            }}
          >
            {value}
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <Box>
      <div className="align_btw brdr">
        <div className="h_1">User Info</div>
      </div>
      <div className="graph_bg">
        <Box sx={{ p: 2 }}>
          <Grid container spacing={3}>
            {/* First row: Username and Email */}
            <Grid item xs={12} md={6}>
              <InfoCard
                icon={AccountCircleIcon}
                label="Username"
                value={userInfo.username}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InfoCard
                icon={EmailIcon}
                label="Email Address"
                value={userInfo.email}
              />
            </Grid>

            {/* Second row: Contact Number and Type */}
            <Grid item xs={12} md={6}>
              <InfoCard
                icon={PhoneIcon}
                label="Contact Number"
                value={userInfo.contactNumber}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InfoCard
                icon={PeopleAltIcon}
                label="User Type"
                value={userInfo.type}
              />
            </Grid>
          </Grid>
        </Box>
      </div>
    </Box>
  )
}

export default UserInfo
